module.exports = __webpack_public_path__ + "img/D-641-660.4de93587.svg";